import useStyles from "./PersonalStyle";
import { Grid } from "@mui/material";
import styles from "../user/student.module.css";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Button from "../../../components/Button";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Gender, NigerianLGAs, CountriesAndState } from "../../../utils/DropDown";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import Select from "react-select";

const CLASSES_ENDPOINT = "/api/v1/class";
const STUDENTS_ENDPOINT = "/api/v1/students";
const UPLOAD_ENDPOINT = "/api/v1/upload";

// --| This Personal Info page is needed on the student info in the user directory
const StudentProfile = ({ data, allGuardian }) => {
  const classes = useStyles();
  const { id } = useParams();
  const [classData, setClassData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedfile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);

  const [personalInfoForm, setPersonalInfoForm] = useState({
    // first_name: data?.first_name,
    // last_name: data?.last_name,
    // admission_date: data?.admission_date,
    // class_admitted: data?.class_id,
    email: data?.email,
    contact: data?.contact,
    guardian: [],
    upload_id: data?.upload_id,
    gender: data?.gender,
    age: data?.age
    // address: ""
  });

  const lgaOptions =
      personalInfoForm?.state && NigerianLGAs[data?.state]
        ? NigerianLGAs[personalInfoForm?.state].map((lga) => ({
          value: lga,
          label: lga
        }))
        : [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPersonalInfoForm({ ...personalInfoForm, [name]: value });

    // If country changes, set its states
    if (name === "country") {
      const selectedCountry = CountriesAndState.find(
        (c) => c.name === value
      );

      if (selectedCountry && selectedCountry.states.length > 0) {
        // Map states into react-select options
        const options = selectedCountry.states.map((s) => ({
          value: s,
          label: s
        }));
        setStateOptions(options);
      } else {
        setStateOptions([]);
      }
    }
  };

  const handleStateChange = (selectedOption) => {
    setPersonalInfoForm((prev) => ({
      ...prev,
      state: selectedOption?.value
    }));
    setSelectedState(selectedOption);
  };

  const guardianOptions = allGuardian?.map((parent) => ({
    value: parent?.guardian_id,
    label: `${parent?.last_name} ${parent?.first_name}`
  })) || [];

  const handleGuardianChange = (selectedOptions, type) => {
    setPersonalInfoForm((prevState) => {
    // Get current guardians of the opposite type
      const otherTypeGuardians = prevState.guardian?.filter(g => g?.type !== type) || [];

      // Prepare newly selected guardians with the correct type
      const newTypeGuardians = selectedOptions
        ? selectedOptions.map(g => ({
          value: g.value,
          label: g.label,
          type
        }))
        : [];

      // Combine both
      const updatedGuardians = [...otherTypeGuardians, ...newTypeGuardians];

      return {
        ...prevState,
        guardian: updatedGuardians
      };
    });
  };

  const handleProfileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setSelectedFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  const handleUpdateInfo = async () => {
  // Convert 'guardian' to 'guardians' with the correct format
    const cleanedGuardians = personalInfoForm.guardian?.map((g) => ({
      guardian_id: g?.value,
      type: g?.type
    })) || [];

    const cleanedForm = {
      ...personalInfoForm,
      guardians: cleanedGuardians
    };
    delete cleanedForm.guardian;

    if (selectedfile) {
      const formData = new FormData();
      formData.append("file", selectedfile);
      try {
        setIsLoading(true);
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
        if (response?.status === 200) {
          const upload_id = response?.data?.data?.[0]?.upload_id;
          const file_url = response?.data?.data?.[0]?.file_url;

          const updatedFormWithImage = {
            ...cleanedForm,
            display_pic: {
              upload_id,
              file_url
            }
          };

          const res = await httprequest.patch(`${STUDENTS_ENDPOINT}/${id}`, updatedFormWithImage);
          setIsLoading(false);
          setSelectedFile(null);
          toast.success(res?.data?.message);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      } catch (error) {
        setIsLoading(false);
        toast.error(error?.response?.data?.message);
      }
    } else {
      setIsLoading(true);
      httprequest
        .patch(`${STUDENTS_ENDPOINT}/${id}`, cleanedForm)
        .then((res) => {
          setIsLoading(false);
          toast.success(res?.data?.message);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err?.response?.data?.message);
        });
    }
  };

  const getAllClasses = () => {
    httprequest.get(CLASSES_ENDPOINT).then((res) => {
      setClassData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  useEffect(() => {
    // The data will be from the Student get api endpint
    setPersonalInfoForm({ ...personalInfoForm,
      // first_name: data?.first_name,
      // last_name: data?.last_name,
      email: data?.email,
      contact: data?.contact,
      guardian: data?.guardian?.map((g) => ({
        value: g?.guardian_id,
        label: `${g?.last_name} ${g?.first_name}`,
        type: g?.type
      })) || [],
      upload_id: data?.upload_id,
      gender: data?.gender,
      age: data?.age });
    getAllClasses();
  }, [data]);

  // populate states whenever country changes
  useEffect(() => {
    if (data?.country) {
      const countryObj = CountriesAndState.find(
        (c) => c.name === data?.country
      );

      if (countryObj && countryObj.states.length > 0) {
        const options = countryObj.states.map((s) => ({
          value: s,
          label: s
        }));
        setStateOptions(options);

        if (data?.state) {
          const match = options.find((opt) => opt.value === data.state) || null;
          setSelectedState(match);
        } else {
          setSelectedState(null);
        }
      } else {
        setStateOptions([]);
        setSelectedState(null);
      }
    } else {
      setStateOptions([]);
      setSelectedState(null);
    }
  }, [data?.country, data?.state]);

  const handleActivateStudent = () => {
    setIsDeleting(true);
    httprequest.patch(`${STUDENTS_ENDPOINT}/${data?.student_id}/reactivate`).then((res) => {
      setIsDeleting(false);
      toast.success(res?.data?.message);
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const { contact, age, gender } = personalInfoForm;

  return (
    <Grid container spacing={2}>
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <div className={`${styles.border} left-container`}>
          <h4>Personal Information</h4>
          <h6>Personal Information of Student</h6>
          <div className={classes.profilecontainer}>
            <div className={classes.imageviewer}>
              {(preview || data?.display_pic?.file_url) && (
                <img
                  src={preview || data?.display_pic?.file_url}
                  alt="profile"
                  className={classes.previewImage}
                />
              )}
              <div className={classes.pickercontainer}>
                <input type="file" accept="image/*" name="profile_picture" className={classes.profilepicker} onChange={handleProfileChange} />
                <CameraAltIcon className={classes.camera} />
              </div>
            </div>
          </div>
          {data?.is_active === false ? <Button variant="primaryoutline" color="btnfontprimary" isLoading={isDeleting} buttonSize="full" onClick={handleActivateStudent} buttonName="Re-activate Student" />
            : <Button variant="primaryoutline" color="btnfontprimary" buttonSize="full" buttonName="Update Personal Information" onClick={handleUpdateInfo} isLoading={isLoading} />}
        </div>
      </Grid>
      <Grid item lg={8} md={8} sm={12} xs={12}>
        <div className={`${styles.border} right-container`}>
          <Grid container spacing={2} className={classes.profileform}>

            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup required inputType="text" label="First name" inputName="first_name"
                onChange={handleChange}
                defaultValue={data?.first_name}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup required inputType="text" label="Last name" inputName="last_name"
                onChange={handleChange}
                defaultValue={data?.last_name}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="text" label="Other name" inputName="other_names"
                onChange={handleChange}
                defaultValue={data?.other_names}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup required inputType="email" disabled label="Email address" inputName="email"
                onChange={handleChange}
                defaultValue={data?.email}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <SelectGroup required label="Country" children={
                <select name="country" onChange={handleChange} defaultValue={data?.country}>
                  <option value="">---Select  ---</option>
                  {CountriesAndState?.map((country, index) => {
                    return (
                      <option key={index} value={country?.name}>{country?.name}</option>
                    );
                  })}
                </select>
              }
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <div className="multiple-select">
                <p className="input-picker-title">State of Origin</p>
                <Select
                  onChange={handleStateChange}
                  options={stateOptions}
                  placeholder="Select State"
                  className="react-select-container"
                  name="state"
                  value={selectedState}
                />
              </div>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
              {data?.country === "Nigeria" ? (
                <div className="multiple-select">
                  <p className="input-picker-title">
            Local Government
                  </p>
                  <Select
                    onChange={handleChange}
                    options={lgaOptions}
                    placeholder="Select LGA"
                    className="react-select-container"
                    name="local_government_area"
                  />
                </div>
              ) : (
                <InputGroup
                  label="Local Government"
                  margin="normal"
                  inputType="text"
                  inputName="local_government_area"
                  defaultValue={data?.local_government_area}
                  onChange={handleChange}
                />
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="text" label="Region" inputName="region"
                onChange={handleChange}
                defaultValue={data?.region}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="text" label="Town" inputName="town"
                onChange={handleChange}
                defaultValue={data?.town}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="text" label="Previous School" inputName="previous_school"
                onChange={handleChange}
                defaultValue={data?.previous_school}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="text" label="Previous Class" inputName="previous_class_passed"
                onChange={handleChange}
                defaultValue={data?.previous_class_passed}
              />
            </Grid>
            <Grid item lg={3} md={3} sm={3} xs={6}>
              <InputGroup inputType="number" label="Height(cm)" inputName="height"
                onChange={handleChange}
                defaultValue={data?.height_cm}
              />
            </Grid>
            <Grid item lg={3} md={3} sm={3} xs={6}>
              <InputGroup inputType="number" label="Weight" inputName="weight"
                onChange={handleChange}
                defaultValue={data?.weight_kg}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="number" label="Age" inputName="age" value={age} onChange={handleChange}
                defaultValue={data?.age}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <SelectGroup required label="Gender" children={
                <select value={gender} name="gender" onChange={handleChange}>
                  <option value="">---Select  ---</option>
                  {Gender?.map((gend) => {
                    return (
                      <option key={gend?.key} value={gend?.key}>{gend?.text}</option>
                    );
                  })}
                </select>
              }
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup required inputType="tel" label="Contact" inputName="contact" value={contact} onChange={handleChange}
                defaultValue={data?.contact}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup required inputType="date" label="Admission Date" inputName="admission_date" value={data?.admission_date ? data.admission_date.substring(0, 10) : ""}
                onChange={handleChange}
                defaultValue={data?.admission_date ? data.admission_date.substring(0, 10) : ""}

              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <SelectGroup required label="Class Admitted to" children={
                <select disabled value={data?.class_id} name="class_admitted" onChange={handleChange} defaultValue={data?.id}>
                  <option value="">---Select Class ---</option>
                  {classData?.map((data) => {
                    return (
                      <option key={data?.id} value={data?.id}>{data?.class_name}</option>
                    );
                  })}
                </select>
              }
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <div className="multiple-select">
                <p>Primary Guardian <span className="input-required">*</span></p>
                <Select
                  name="guardian"
                  options={guardianOptions}
                  onChange={(option) => handleGuardianChange(option, "primary")}
                  value={personalInfoForm?.guardian
                    ?.filter(g => g?.type === "primary")
                    ?.map(g => ({
                      value: g?.value,
                      label: g?.label
                    }))}
                  isClearable
                  isSearchable
                  isMulti
                />
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <div className="multiple-select">
                <p>Secondary Guardian <span className="input-required">*</span></p>
                <Select
                  name="guardian"
                  options={guardianOptions}
                  onChange={(option) => handleGuardianChange(option, "secondary")}
                  value={personalInfoForm?.guardian
                    ?.filter(g => g?.type === "secondary")
                    ?.map(g => ({
                      value: g?.value,
                      label: g?.label
                    }))}
                  isClearable
                  isSearchable
                  isMulti
                />
              </div>
            </Grid>
          </Grid>
          {/* <ToastContainer /> */}
        </div>
      </Grid>
    </Grid>
  );
};

export default StudentProfile;
